export default __webpack_public_path__ + "static/media/gallery04.d5eee103.png";